/* eslint-disable camelcase, class-methods-use-this */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        width: '100%',
        backgroundColor: '#000', // Changed to black to match slide backgrounds
        color: '#fff',
        fontFamily: 'Roboto, sans-serif',
        padding: '20px',
        textAlign: 'center',
        boxSizing: 'border-box',
    },
    fullscreen: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#000',
        color: '#fff',
        fontFamily: 'Roboto, sans-serif',
        padding: '20px',
        textAlign: 'center',
        userSelect: 'none',
        zIndex: 1000,
        boxSizing: 'border-box',
    },
    heading: {
        fontSize: '28px',
        fontWeight: 'bold',
        marginBottom: '20px',
        color: 'inherit',
    },
    text: {
        fontSize: '18px',
        marginBottom: '15px',
        maxWidth: '600px',
        color: 'inherit',
    },
    btn: {
        marginTop: '30px',
        padding: '10px 30px',
        fontSize: '18px',
    },
    fullscreenTap: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#000',
        color: '#fff',
        fontFamily: 'Roboto, sans-serif',
        padding: '40px',
        textAlign: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        zIndex: 1000,
        boxSizing: 'border-box',
    },
    content: {
        maxWidth: '650px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
    },
    instructionText: {
        fontSize: '18px',
        lineHeight: '1.6',
        margin: 0,
        color: '#ccc',
        textAlign: 'left',
        width: '100%',
    },
    tapPrompt: {
        fontSize: '20px',
        fontWeight: 'bold',
        marginTop: '30px',
        color: '#fff',
        animation: 'flankerPulse 2s infinite',
    },
};

export default class Flanker extends Component {
    static propTypes = {
        block: PropTypes.object.isRequired,
        onContinue: PropTypes.func.isRequired,
        updateAnswer: PropTypes.func.isRequired,
        answer: PropTypes.object,
    };

    static canContinue(answer) {
        // Return falsy when the task is complete (no missing info), truthy string when blocked
        if (answer && typeof answer === 'string') {
            try {
                const data = JSON.parse(answer);
                if (data.main_trials && data.main_trials.length > 0) {
                    return false; // Can continue — task is done
                }
            } catch (e) { /* ignore parse errors */ }
        }
        return 'Please complete the Flanker task first.';
    }

    constructor(props) {
        super(props);
        this.state = {
            stage: 'intro', // intro, practice_intro, practice, practice_probes, main_intro, main, rest, probes, completed
            trialIndex: 0,
            practiceTrials: [],
            mainTrials: [],
            probes: [],
            blockNr: 1, // 1 to 3
            currentTrialPhase: null, // fixation, stimulus, response
            probeIndex: 0,

            // recorded answers
            recordedPractice: [],
            recordedMain: [],
            recordedProbes: [],
            recordedPracticeProbes: [], // track practice probe responses

            countdown: 10, // for rest
            timerLeft: 8, // for probes
            sliderValue: 3, // default slider value (middle of 0-6)
            sliderTouched: false, // track whether the user interacted with the slider
            currentProbeAnswers: {}, // temp store for the 3 probe answers of a block

            isPortrait: this.checkIsPortrait(), // orientation lock
        };

        this.fixationTimeout = null;
        this.stimulusTimeout = null;
        this.probeInterval = null;
        this.restInterval = null;
    }

    checkIsPortrait() {
        if (typeof window !== 'undefined') {
            return window.innerHeight > window.innerWidth;
        }
        return false;
    }

    handleOrientationChange = () => {
        this.setState({isPortrait: this.checkIsPortrait()});
    }

    componentDidMount() {
        this.generateTrials();
        // Keyboard support for Left (ArrowLeft) and Right (ArrowRight)
        window.addEventListener('keydown', this.handleKeyDown);
        // Orientation detection for landscape lock
        window.addEventListener('resize', this.handleOrientationChange);
        if (screen.orientation) {
            screen.orientation.addEventListener('change', this.handleOrientationChange);
        }
    }

    componentWillUnmount() {
        this.clearAllTimeouts();
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('resize', this.handleOrientationChange);
        if (screen.orientation) {
            screen.orientation.removeEventListener('change', this.handleOrientationChange);
        }
    }

    handleKeyDown = e => {
        if (this.state.stage === 'practice' || this.state.stage === 'main') {
            if (this.state.currentTrialPhase === 'stimulus' || this.state.currentTrialPhase === 'response') {
                if (e.key === 'ArrowLeft') {
                    this.handleResponse('left');
                } else if (e.key === 'ArrowRight') {
                    this.handleResponse('right');
                }
            }
        }
    }

    clearAllTimeouts() {
        if (this.fixationTimeout) clearTimeout(this.fixationTimeout);
        if (this.stimulusTimeout) clearTimeout(this.stimulusTimeout);
        if (this.probeInterval) clearInterval(this.probeInterval);
        if (this.restInterval) clearInterval(this.restInterval);
    }

    generateTrials() {
        // Generate practice trials: 30 trials (15 congruent, 15 incongruent)
        const practiceTrials = this.createBlock(30);
        // Generate main trials blocks: 3 blocks x 80 trials each
        const mainTrials1 = this.createBlock(80);
        const mainTrials2 = this.createBlock(80);
        const mainTrials3 = this.createBlock(80);

        this.setState({
            practiceTrials,
            mainTrials: [mainTrials1, mainTrials2, mainTrials3],
        });
    }

    createBlock(count) {
        const trials = [];
        const half = count / 2;

        // Congruent
        for (let i = 0; i < half; i++) {
            const targetDirection = (i % 2 === 0) ? 'left' : 'right';
            trials.push({
                condition: 'congruent',
                target_direction: targetDirection,
                correct_response: targetDirection,
                fixation_ms: this.getRandomFixation(),
            });
        }

        // Incongruent
        for (let i = 0; i < half; i++) {
            const targetDirection = (i % 2 === 0) ? 'left' : 'right';
            trials.push({
                condition: 'incongruent',
                target_direction: targetDirection,
                correct_response: targetDirection,
                fixation_ms: this.getRandomFixation(),
            });
        }

        return this.shuffle(trials);
    }

    getRandomFixation() {
        const fixations = [200, 500, 800];
        return fixations[Math.floor(Math.random() * fixations.length)];
    }

    shuffle(array) {
        const newArr = [...array];
        for (let i = newArr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
        }
        return newArr;
    }

    startPractice = () => {
        this.setState({stage: 'practice', trialIndex: 0}, this.startTrial);
    }

    startMain = () => {
        this.setState({stage: 'main', trialIndex: 0, blockNr: 1}, this.startTrial);
    }

    startTrial = () => {
        const {stage, trialIndex, blockNr, practiceTrials, mainTrials} = this.state;
        let trial;
        if (stage === 'practice') {
            trial = practiceTrials[trialIndex];
        } else if (stage === 'main') {
            trial = mainTrials[blockNr - 1][trialIndex];
        }

        if (!trial) return;

        this.setState({currentTrialPhase: 'fixation', stimulusShownAt: null, currentTrial: trial});

        this.fixationTimeout = setTimeout(() => {
            this.setState({currentTrialPhase: 'stimulus', stimulusShownAt: Date.now()});

            this.stimulusTimeout = setTimeout(() => {
                this.setState({currentTrialPhase: 'response'});
            }, 200); // 200ms stimulus duration
        }, trial.fixation_ms);
    }

    handleResponse = participantResponse => {
        const {
            stage,
            currentTrial,
            stimulusShownAt,
            recordedPractice,
            recordedMain,
            trialIndex,
            blockNr,
            currentTrialPhase,
        } = this.state;

        if (!stimulusShownAt || !currentTrial) {
            return;
        }
        if (currentTrialPhase !== 'stimulus' && currentTrialPhase !== 'response') {
            return;
        }

        this.clearAllTimeouts();

        const RT = Date.now() - stimulusShownAt;
        const accuracy = participantResponse === currentTrial.correct_response ? 1 : 0;

        const record = {
            trial_nr: trialIndex + 1,
            condition: currentTrial.condition,
            target_direction: currentTrial.target_direction,
            correct_response: currentTrial.correct_response,
            participant_response: participantResponse,
            accuracy,
            RT,
            fixation_ms: currentTrial.fixation_ms,
            block_nr: stage === 'practice' ? 0 : blockNr,
        };

        if (stage === 'practice') {
            this.setState({
                recordedPractice: [...recordedPractice, record],
            }, this.nextTrial);
        } else {
            this.setState({
                recordedMain: [...recordedMain, record],
            }, this.nextTrial);
        }
    }

    nextTrial = () => {
        const {
            stage,
            trialIndex,
            blockNr,
            practiceTrials,
            mainTrials,
        } = this.state;

        if (stage === 'practice') {
            if (trialIndex + 1 < practiceTrials.length) {
                this.setState({trialIndex: trialIndex + 1}, this.startTrial);
            } else {
                this.initProbes('practice_probes');
            }
        } else if (stage === 'main') {
            if (trialIndex + 1 < mainTrials[blockNr - 1].length) {
                this.setState({trialIndex: trialIndex + 1}, this.startTrial);
            } else {
                this.initProbes('probes');
            }
        }
    }

    initProbes = stageName => {
        this.setState({
            stage: stageName,
            probeIndex: 0,
            timerLeft: 8,
            sliderValue: 3,
            sliderTouched: false,
            currentProbeAnswers: {},
        });
        if (this.probeInterval) {
            clearInterval(this.probeInterval);
        }
        this.probeInterval = setInterval(() => {
            const {timerLeft, sliderValue, sliderTouched} = this.state;
            if (timerLeft <= 1) {
                this.handleProbeResponse(sliderTouched ? sliderValue : null);
            } else {
                this.setState({timerLeft: timerLeft - 1});
            }
        }, 1000);
    }

    handleProbeResponse = score => {
        clearInterval(this.probeInterval);
        const {
            stage,
            blockNr,
            probeIndex,
            recordedProbes,
            recordedPracticeProbes,
        } = this.state;

        const probeNames = ['Mindwandering_focus', 'Mindwandering_distracted', 'Metacognition'];
        const questionName = probeNames[probeIndex];

        this.setState(prevState => {
            const currentProbeAnswers = {
                ...prevState.currentProbeAnswers,
                [questionName]: score !== null ? score : 'NA',
            };
            return {currentProbeAnswers};
        }, () => {
            if (probeIndex + 1 < 3) {
                this.startProbesNextQuestion();
            } else {
                const {currentProbeAnswers} = this.state;
                const record = {
                    block_nr: stage === 'practice_probes' ? 0 : blockNr,
                    ...currentProbeAnswers,
                };

                if (stage === 'practice_probes') {
                    this.setState({
                        recordedPracticeProbes: [...recordedPracticeProbes, record],
                        currentProbeAnswers: {},
                    }, () => {
                        this.setState({stage: 'main_intro'});
                    });
                } else {
                    this.setState({
                        recordedProbes: [...recordedProbes, record],
                        currentProbeAnswers: {},
                    }, () => {
                        this.finishBlock();
                    });
                }
            }
        });
    }

    startProbesNextQuestion = () => {
        this.setState(prevState => ({
            probeIndex: prevState.probeIndex + 1,
            timerLeft: 8,
            sliderValue: 3,
            sliderTouched: false,
        }));
        if (this.probeInterval) {
            clearInterval(this.probeInterval);
        }
        this.probeInterval = setInterval(() => {
            const {timerLeft, sliderValue, sliderTouched} = this.state;
            if (timerLeft <= 1) {
                this.handleProbeResponse(sliderTouched ? sliderValue : null);
            } else {
                this.setState({timerLeft: timerLeft - 1});
            }
        }, 1000);
    }

    finishBlock = () => {
        const {blockNr} = this.state;
        if (blockNr < 3) {
            this.setState({stage: 'rest', countdown: 10});
            this.restInterval = setInterval(() => {
                const {countdown} = this.state;
                if (countdown <= 1) {
                    clearInterval(this.restInterval);
                    this.setState({stage: 'main', blockNr: blockNr + 1, trialIndex: 0}, this.startTrial);
                } else {
                    this.setState({countdown: countdown - 1});
                }
            }, 1000);
        } else {
            this.finishTask();
        }
    }

    finishTask = () => {
        const {
            recordedPractice,
            recordedMain,
            recordedProbes,
            recordedPracticeProbes,
        } = this.state;
        this.setState({stage: 'completed'});

        const answerData = {
            practice_trials: recordedPractice,
            main_trials: recordedMain,
            probes: recordedProbes,
            practice_probes: recordedPracticeProbes,
        };

        this.props.updateAnswer(JSON.stringify(answerData));
    }

    renderStimulus(trial) {
        const condition = trial.condition;
        const targetDirection = trial.target_direction;
        let arrows = '';
        if (targetDirection === 'left') {
            arrows = condition === 'congruent' ? '<<<<<' : '>><>>';
        } else {
            arrows = condition === 'congruent' ? '>>>>>' : '<<><<';
        }

        return (
            <div style={{fontSize: '10vh', letterSpacing: '10px', color: '#fff', textAlign: 'center', userSelect: 'none'}}>
                {arrows}
            </div>
        );
    }

    renderIntro() {
        return (
            <div
                className="flanker-container"
                style={styles.fullscreenTap}
                onClick={() => this.setState({stage: 'practice_intro'})}>
                <div style={styles.content}>
                    <p style={styles.instructionText}>
                        {'In the following task, you will complete a series of trials. Each trial begins with a fixation cross displayed at the center of the screen, followed by a row of five arrows.'}
                    </p>
                    <p style={styles.instructionText}>
                        {'Your task is to focus only on the '}<strong>{'middle arrow'}</strong>{' and ignore the arrows surrounding it.'}
                    </p>
                    <p style={styles.instructionText}>
                        {'If the middle arrow points to the right, press the right button. If the middle arrow points to the left, press the left button.'}
                    </p>
                    <p style={styles.instructionText}>
                        {'Some trials will be easier because all arrows point in the same direction, while others will be more difficult because the surrounding arrows point in the opposite direction. The surrounding arrows are irrelevant to the decision.'}
                    </p>
                    <p style={styles.instructionText}>
                        {'Please respond as quickly and accurately as possible.'}
                    </p>
                    <div style={styles.tapPrompt}>{'Touch the screen to continue'}</div>
                </div>
            </div>
        );
    }

    renderPracticeIntro() {
        return (
            <div
                className="flanker-container"
                style={styles.fullscreenTap}
                onClick={this.startPractice}>
                <div style={styles.content}>
                    <p style={styles.instructionText}>
                        {'Before starting the main task, you will complete a short practice round to familiarize yourself with the task and the response buttons.'}
                    </p>
                    <p style={styles.instructionText}>
                        {'Please use this practice session to make sure you understand the instructions and feel comfortable responding to the arrows.'}
                    </p>
                    <div style={styles.tapPrompt}>
                        {'When you are ready, touch the screen to begin the practice round.'}
                    </div>
                </div>
            </div>
        );
    }

    renderMainIntro() {
        return (
            <div
                className="flanker-container"
                style={styles.fullscreenTap}
                onClick={this.startMain}>
                <div style={styles.content}>
                    <p style={styles.instructionText}>
                        {'You will now begin the main task.'}
                    </p>
                    <p style={styles.instructionText}>
                        {'Remember to focus only on the middle arrow and ignore the surrounding arrows. Respond as quickly and accurately as possible throughout the task.'}
                    </p>
                    <p style={styles.instructionText}>
                        {'At the end of each block, you will also be asked a few short questions about your attention and performance during the task.'}
                    </p>
                    <div style={styles.tapPrompt}>
                        {'When you are ready, touch the screen to begin the main task.'}
                    </div>
                </div>
            </div>
        );
    }

    renderRest() {
        return (
            <div className="flanker-container" style={styles.fullscreen}>
                <div style={styles.content}>
                    <h2 style={styles.heading}>{'Rest'}</h2>
                    <p style={styles.instructionText}>{'Please take a short break.'}</p>
                    <p style={styles.instructionText}>
                        {'The next block will start in '}<strong>{this.state.countdown}</strong>{' seconds.'}
                    </p>
                </div>
            </div>
        );
    }

    handleSliderChange = e => {
        this.setState({
            sliderValue: parseInt(e.target.value, 10),
            sliderTouched: true,
        });
    }

    renderProbes() {
        const {probeIndex, timerLeft, sliderValue, sliderTouched} = this.state;
        const probeQuestions = [
            'Were you focused on the task?',
            'Were you thinking of something else?',
            'How confident were you of the accuracy of your performance during the last block?',
        ];

        return (
            <div className="flanker-container" style={styles.fullscreen}>
                <style>{`
                    .flanker-slider-wrapper {
                        position: relative;
                        width: 100%;
                        max-width: 500px;
                        margin: 40px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .flanker-slider-container {
                        position: relative;
                        width: 100%;
                        height: 40px;
                        display: flex;
                        align-items: center;
                    }
                    .flanker-slider-input {
                        width: 100%;
                        height: 8px;
                        background: #444;
                        border-radius: 4px;
                        outline: none;
                        -webkit-appearance: none;
                        appearance: none;
                        position: relative;
                        z-index: 2;
                    }
                    .flanker-slider-input::-webkit-slider-thumb {
                        -webkit-appearance: none;
                        appearance: none;
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        background: #fff;
                        cursor: pointer;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.5);
                        border: 1px solid #999;
                    }
                    .flanker-slider-input::-moz-range-thumb {
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        background: #fff;
                        cursor: pointer;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.5);
                        border: 1px solid #999;
                    }
                    .flanker-slider-input.untouched::-webkit-slider-thumb {
                        visibility: hidden;
                    }
                    .flanker-slider-input.untouched::-moz-range-thumb {
                        visibility: hidden;
                    }
                    .flanker-slider-ticks-lines {
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        padding: 0 13px;
                        box-sizing: border-box;
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translateY(-50%);
                        pointer-events: none;
                        z-index: 3;
                    }
                    .tick-line {
                        width: 2px;
                        height: 18px;
                        background-color: #888;
                    }
                    .flanker-slider-labels {
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        color: #fff;
                        font-size: 14px;
                        margin-top: 10px;
                    }
                    .flanker-slider-ticks {
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        color: #fff;
                        font-size: 16px;
                        font-weight: bold;
                        margin-bottom: 10px;
                        padding: 0 8px;
                        box-sizing: border-box;
                    }
                `}</style>
                <div style={{position: 'absolute', top: 0, left: 0, height: '5px', backgroundColor: '#4caf50', width: `${(timerLeft / 8) * 100}%`, transition: 'width 1s linear'}} />

                <div style={styles.content}>
                    <h3 style={{fontSize: '24px', lineHeight: '1.4', color: '#fff', margin: '0 0 20px 0'}}>
                        {probeQuestions[probeIndex]}
                    </h3>

                    <div className="flanker-slider-wrapper">
                        <div className="flanker-slider-ticks">
                            <span>{'0'}</span>
                            <span>{'6'}</span>
                        </div>
                        <div className="flanker-slider-container">
                            <div className="flanker-slider-ticks-lines">
                                {[0, 1, 2, 3, 4, 5, 6].map(tick => (
                                    <span key={tick} className="tick-line" />
                                ))}
                            </div>
                            <input
                                type="range"
                                min="0"
                                max="6"
                                step="1"
                                value={sliderValue}
                                onChange={this.handleSliderChange}
                                className={`flanker-slider-input ${!sliderTouched ? 'untouched' : ''}`}
                            />
                        </div>
                        <div className="flanker-slider-labels">
                            <span>{'Not at all'}</span>
                            <span>{'Completely'}</span>
                        </div>
                    </div>

                    {sliderTouched ? (
                        <button
                            className="btn waves-effect waves-light"
                            style={{marginTop: '20px', backgroundColor: '#fff', color: '#000', alignSelf: 'center', fontWeight: 'bold'}}
                            onClick={() => this.handleProbeResponse(sliderValue)}>
                            {'Confirm'}
                        </button>
                    ) : (
                        <div style={{height: '56px'}} />
                    )}
                </div>
            </div>
        );
    }

    renderCompleted() {
        return (
            <div className="flanker-container" style={styles.fullscreen}>
                <div style={styles.content}>
                    <h2 style={styles.heading}>{'Task Completed'}</h2>
                    <p style={styles.instructionText}>{'Thank you for completing the Flanker task.'}</p>
                    <button className="btn waves-effect waves-light" style={{...styles.btn, backgroundColor: '#4caf50'}} onClick={this.props.onContinue}>{'Continue'}</button>
                </div>
            </div>
        );
    }

    renderTrial() {
        const {currentTrialPhase, currentTrial} = this.state;

        return (
            <div className="flanker-container" style={styles.fullscreen}>
                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
                    {currentTrialPhase === 'fixation' && (
                        <div style={{color: '#fff', fontSize: '60px'}}>{'+'}</div>
                    )}
                    {currentTrialPhase === 'stimulus' && currentTrial && (
                        this.renderStimulus(currentTrial)
                    )}
                    {currentTrialPhase === 'response' && (
                        <div style={{width: '100%', height: '100%'}} />
                    )}
                </div>

                <div style={{height: '120px', display: 'flex', width: '100%', padding: '10px', gap: '10px'}}>
                    <div
                        style={{flex: 1, backgroundColor: '#333', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', fontSize: '40px', cursor: 'pointer', userSelect: 'none'}}
                        onPointerDown={() => this.handleResponse('left')}>
                        {'<'}
                    </div>
                    <div
                        style={{flex: 1, backgroundColor: '#333', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', fontSize: '40px', cursor: 'pointer', userSelect: 'none'}}
                        onPointerDown={() => this.handleResponse('right')}>
                        {'>'}
                    </div>
                </div>
            </div>
        );
    }

    renderLandscapeOverlay() {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#000',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                fontFamily: 'Roboto, sans-serif',
                padding: '40px',
                textAlign: 'center',
            }}>
                <div style={{fontSize: '60px', marginBottom: '30px', animation: 'flankerRotate 2s ease-in-out infinite'}}>
                    {'↻'}
                </div>
                <h2 style={{fontSize: '24px', fontWeight: 'bold', marginBottom: '15px'}}>{'Please rotate your device'}</h2>
                <p style={{fontSize: '16px', color: '#ccc', maxWidth: '300px'}}>{'This task requires landscape (horizontal) mode. Please turn your phone sideways to continue.'}</p>
                <style>{`
                    @keyframes flankerRotate {
                        0%, 100% { transform: rotate(0deg); }
                        50% { transform: rotate(90deg); }
                    }
                `}</style>
            </div>
        );
    }

    render() {
        const {stage, isPortrait} = this.state;

        if (isPortrait) return this.renderLandscapeOverlay();

        return (
            <div>
                <style>{`
                    @keyframes flankerPulse {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.4; }
                    }
                `}</style>
                {stage === 'intro' && this.renderIntro()}
                {stage === 'practice_intro' && this.renderPracticeIntro()}
                {(stage === 'practice' || stage === 'main') && this.renderTrial()}
                {stage === 'practice_probes' && this.renderProbes()}
                {stage === 'main_intro' && this.renderMainIntro()}
                {stage === 'rest' && this.renderRest()}
                {stage === 'probes' && this.renderProbes()}
                {stage === 'completed' && this.renderCompleted()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Flanker.js